module.exports = __webpack_public_path__ + "static/media/Spanish_Flag.12589923.png";